import { FaCalendarAlt, FaSearch } from 'react-icons/fa';
import { MdDashboard, MdDesignServices, MdContactSupport } from 'react-icons/md';
import { IoIosSettings } from 'react-icons/io';
import { BsPeopleFill } from 'react-icons/bs';
import { GiChicken } from 'react-icons/gi';
import { FaMoneyCheck } from "react-icons/fa";
import { RiComputerFill } from "react-icons/ri";
import { MdMenuBook } from "react-icons/md";
import { IoLogOut } from "react-icons/io5";

// Grouped navigation. Groups encode how an owner thinks about their day:
// what's happening now, the business they run, how they grow it, their account.
export const MenuGroups = [
  {
    title: 'sidebar.groups.today',
    items: [
      { title: 'sidebar.menu.overview',      iconStyle: <MdDashboard />,      to: 'overview' },
      { title: 'sidebar.menu.calendar',      iconStyle: <FaCalendarAlt />,    to: 'calendar' },
      { title: 'sidebar.menu.roster',        iconStyle: <GiChicken />,        to: 'roster' },
      { title: 'sidebar.menu.search',        iconStyle: <FaSearch />,         to: 'search' },
    ],
  },
  {
    title: 'sidebar.groups.business',
    items: [
      { title: 'sidebar.menu.services',      iconStyle: <MdDesignServices />, to: 'manage-services' },
      { title: 'sidebar.menu.staff',         iconStyle: <BsPeopleFill />,     to: 'manage-staff' },
      { title: 'sidebar.menu.payments',      iconStyle: <FaMoneyCheck />,     to: 'payments' },
    ],
  },
  {
    title: 'sidebar.groups.grow',
    items: [
      { title: 'sidebar.menu.onlineBooking', iconStyle: <MdMenuBook />,       to: 'online-booking' },
      { title: 'sidebar.menu.miniSite',      iconStyle: <RiComputerFill />,   to: 'manage-site' },
    ],
  },
  {
    title: 'sidebar.groups.account',
    items: [
      { title: 'sidebar.menu.support',       iconStyle: <MdContactSupport />, to: 'support' },
      { title: 'sidebar.menu.settings',      iconStyle: <IoIosSettings />,    to: 'settings' },
    ],
  },
];

// Flat list kept for route/active-item lookups elsewhere.
export const MenuList = [
  ...MenuGroups.flatMap(group => group.items),
  { title: 'sidebar.menu.logout', iconStyle: <IoLogOut />, to: 'logout' },
];
